import { render, staticRenderFns } from "./App.vue?vue&type=template&id=94d80f30"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=94d80f30&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_5a3c64a85473ede7d9205802ebc6db0e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports